module.exports = __webpack_public_path__ + "static/media/home.40667835.svg";